import { Action, action } from 'easy-peasy';
// eslint-disable-next-line
import * as Device from 'expo-device';

interface Error {
  incidentId: string | null;
  error: {
    message?: string;
    stack?: string;
  };
  device: Partial<Omit<typeof Device, 'DeviceType'>> & {
    userAgent?: string;
  };
}

export interface ErrorsModel {
  errors: Error[];
  addError: Action<ErrorsModel, Error>;
  pruneErrors: Action<ErrorsModel>;
}

export const errors: ErrorsModel = {
  errors: [],
  addError: action((state, payload) => {
    state.errors.push(payload);
  }),
  pruneErrors: action((state) => {
    state.errors = [];
  }),
};
